import * as activePackage from '@default/app';
import type { FC } from 'react';

// App is present in every package — imported via named import (type-safe, no warnings).
// checkAccess/AccessDeniedScreen are optional: the package from NX_PUBLIC_PACKAGE_NAME might not export them.
// We read them through an intermediate variable using dynamic key access so the bundler doesn't link
// the names statically (otherwise: ESModulesLinkingWarning: 'checkAccess' was not found).
const pkg = activePackage as unknown as Record<string, unknown>;

// Access check function, provided by the active package (as in the former GateRoute).
export const checkAccess = pkg['checkAccess'] as (() => boolean) | undefined;

// Screen component rendered on a failed check, provided by the active package.
export const AccessDeniedScreen = pkg['AccessDeniedScreen'] as FC<{ onUnlock: () => void }> | undefined;
